// store.js
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    dadoslancto: {

    },
  },
  mutations: {
    definelancto(state, payload){
      state.dadoslancto = payload
    }
  }
})
